import React from 'react'
import { Search } from 'lucide-react'
import AppInputIcon from 'components/atoms/AppInputIcon/AppInputIcon'

interface SearchInputProps {
    placeholder?: string
    onSubmit?: (e: React.FormEvent<HTMLFormElement>) => void
    value?: string
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
    className?: string
    disabled?: boolean
}

const SearchInput = React.forwardRef<HTMLInputElement, SearchInputProps>(
    ({
        placeholder = 'Buscar...',
        onSubmit,
        value,
        onChange,
        disabled = false,
        ...rest
    }) => {
        const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
            e.preventDefault()
            if (onSubmit) {
                onSubmit(e)
            }
        }

        return (
            <form onSubmit={handleSubmit} className={`flex ${rest.className}`}>
                <AppInputIcon
                    type="text"
                    placeholder={placeholder}
                    onChange={onChange}
                    value={value}
                    disabled={disabled}
                    iconLeft={<Search size={20} className="text-gray-400" />}
                    className={`w-full px-4 text-gray-700 placeholder-gray-400 bg-white rounded-2xl border border-gray-200 focus:border-gray-300 `}
                    onSubmit={() => {}}
                    {...rest}
                />
            </form>
        )
    }
)

SearchInput.displayName = 'SearchInput'

export default SearchInput
